import { CrudMode, DataDisplay, Grid, pn, useElementBreakpoints, ValidationErrors } from "@compass/core";
import { Input } from "components";
import { ContributorMatchService, ContributorMatchServiceViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const ContributorMatchServicePageBody = (props: {
  crudMode: CrudMode;
  contributorMatchService: ContributorMatchService;
  setContributorMatchService: (value: ContributorMatchService) => void;
  viewResource: ContributorMatchServiceViewResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, fullFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const nameField = () => {
    const propertyName = pn<ContributorMatchService>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.contributorMatchService.name}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.contributorMatchService.name}
        onChange={(e) =>
          props.setContributorMatchService(
            produce(props.contributorMatchService, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={fullFieldBreakpoints}>
        {nameField()}
      </Grid>
    </Grid>
  );
};
